import { useEffect, useState } from 'react';
import { getDatesForDateRange } from '@general/dates';

const useDatesForDateRange = ({ startDate, endDate }) => {
    const [dates, setDates] = useState([]);

    useEffect(() => {
        if (!startDate || !endDate) {
            return;
        }

        setDates(getDatesForDateRange({ startDate, endDate }));
    }, [startDate, endDate]);

    return dates;
};

export default useDatesForDateRange;
